import { ListRange, SearchCriteriaBase } from '../../../../../../../common/models/list.model';
import { DEFAULT_PAGE_SIZE } from '../../../../../../../common/constants/table-config';
import { ListQueryParam } from '../../../../../../../common/constants/list-query-param.constant';
import { CountryCodes } from '../../../../../../../common/constants/countries';
import { UliActivityType } from '../../../../../../../common/constants/uli';

export class TrailerHandlingCouplingPlanModel {
  trailerPlate: string;
  country: CountryCodes;
  carrier: string;
  loadNumber: string;
  truckId: number;
  webCouplingReadyUliDetailsView: {
    uli: string;
    type: UliActivityType;
  };

  constructor(params?: TrailerHandlingCouplingPlanModel) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export interface TrailerHandlingListURIParams {
  hubId: number;
  searchCriteria: CouplingPlanSearchCriteria;
}

export class CouplingPlanSearchCriteria extends SearchCriteriaBase {
  [ListQueryParam.LoadNumberFilter] = '';
  [ListQueryParam.TrailerPlateFilter] = '';
  [ListQueryParam.Size] = DEFAULT_PAGE_SIZE;
  [ListQueryParam.Page] = 0;

  constructor(params?: CouplingPlanSearchCriteria | ListRange) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}
